import styled, { keyframes } from "styled-components";

const shimmer = keyframes`
  0% { opacity: 0.4 }
  50% { opacity: 1 }
  100% { opacity: 0.4 }
`;

const Wrapper = styled.div`
  height: 60px;
  border-radius: 8px;
  background: #2a2a2a;
  animation: ${shimmer} 1.4s infinite;
`;

const CreatorSkeleton = () => <Wrapper />;

export default CreatorSkeleton;
